module.exports = __webpack_public_path__ + "static/media/ad99b615-912e-fcce-1b7a-c596928d579c.e36893ca.jpg";